// Asset-class constants for the hunt-scope step/tabs. These live in their own
// module (rather than in HuntScopeStep.tsx) so the component files only export
// components — satisfying the react-refresh/only-export-components lint rule.

export const EXTERNAL_SCOPE_ASSET_CLASSES = [
  'domain',
  'tld',
  'ipv4',
  'ipv6',
  'cidr',
];
export const CLOUD_SCOPE_ASSET_CLASSES = ['amazon', 'azure', 'gcp'];
// Per-tab subsets of the external pool (see HuntScopeTabs). Each is a strict
// subset of EXTERNAL_SCOPE_ASSET_CLASSES so a tab can never widen the pool.
export const DOMAIN_SCOPE_ASSET_CLASSES = ['domain', 'tld'];
export const CIDR_SCOPE_ASSET_CLASSES = ['cidr'];
